export default __webpack_public_path__ + "static/media/smiley_rating_medium.1c9f7873.svg";